import { CircularProgress, Modal as MTModal } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const Modal = styled(MTModal)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: none;
`;

const Progress = styled(CircularProgress)`
  &:focus {
    outline: none !important;
  }
`;

export function Spinner({ loading, modalProps = {} }) {
  return (
    <Modal open={loading} {...modalProps}>
      <Progress />
    </Modal>
  );
}
